import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Events } from '../global/constants';

// ---------- Cursor ----------

$Elements.Cursor.each(function() {

	const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
	const mouse = { x: pos.x, y: pos.y };
	const speed = 1;

	const xSet = gsap.quickSetter(this, "x", "px");
	const ySet = gsap.quickSetter(this, "y", "px");

	window.addEventListener("mousemove", e => {
		mouse.x = e.x;
		mouse.y = e.y;
	});

	gsap.set(this, { xPercent: -50, yPercent: -50 });

	gsap.ticker.add(() => {

		const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

		pos.x += (mouse.x - pos.x) * dt;
		pos.y += (mouse.y - pos.y) * dt;
		xSet(pos.x);
		ySet(pos.y);
	});
});


// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	// ---------- Animations ----------

	$Elements.document.on('mouseenter', 'a, button, select, input', () => $Elements.Cursor.addClass('hover'));
	$Elements.document.on('mouseleave', 'a, button, select, input', () => $Elements.Cursor.removeClass('hover'));

};

$Elements.document.on(Events.page.enter, () => initBaseAnimations());
